
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/politique-confidentialite",
      function () {
        return require("private-next-pages/politique-confidentialite.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/politique-confidentialite"])
      });
    }
  